export default __webpack_public_path__ + "static/media/corporate9.e996fc1b.png";